<div class="control-box">
  <div [innerHTML]="title" class="title"></div>
  <div [innerHTML]="subtitle" class="subtitle"></div>
  <div class="services">
    @for (s of services; track s; let idx = $index) {
      <div class="button-container">
        <app-service-button (selected)="onChange(s)" [disabled]="noAppSelected" [service]="s"></app-service-button>
      </div>
    }
  </div>
</div>
